export const HIDDEN_VOUCHER_TOGGLE: App.VoucherToggle = 'is-hidden'

export function isVoucherHidden(voucher: { voucherToggles?: ReadonlyArray<App.VoucherToggle> }): boolean {
  return voucher.voucherToggles?.includes(HIDDEN_VOUCHER_TOGGLE) ?? false
}
